'use strict';

import type { CommissionStatementResult } from '../../Entities/CommissionStatement/CommissionStatementResult';
import { EntityCollection } from '../EntityCollection';

/**
 * Collection class for managing CommissionStatementResult entities
 * Extends EntityCollection to provide type-safe operations for commission statement results
 */
export class CommissionStatementResultCollection extends EntityCollection<CommissionStatementResult> {}
